import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { UtilService } from '../../service/util.service';
import { ReportService } from '../../pages/report/report.service';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-bdp-detail',
  templateUrl: './bdp-detail.component.html',
  styleUrls: ['./bdp-detail.component.scss'],
})
export class BdpDetailComponent implements OnInit {

  @Input() warehouseId: any;
  @Input() productId: any;
  
  token: any;
  productData: any;
  productName: any;
  warehouseName: any;
  productUnit: any;
  title : any;
  bdpData:any[]=[];
  constructor(
    public modalController: ModalController,
    private storage: Storage,
    private toastCtrl: ToastController,
    private navCtrl: NavController,
    private utilService: UtilService,
    private reportService: ReportService) { }

  ngOnInit() {
    this.storage.get('user_token')
    .then((token) => {
      if(token) {
        this.token = token;
        this.title = '';
        this.getData();
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  getData() {
    this.bdpData = [];
    let options = {
      "token": this.token,
      "warehouse_id": this.warehouseId,
      "product_id": this.productId,
    }
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      this.reportService.getBdpDetail(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.productData = response.results.product_data;
          if(this.productData){
            this.productName = this.productData.product_name;
            this.productUnit = this.productData.unit;
          }
          this.bdpData = response.results.outstanding_data;
          console.log(this.bdpData)
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      })
    });
  }

  async dismissModal() {
    const close: string = "Modal Removed";
    await this.modalController.dismiss(close);
  }
}
